import { call, put, takeLatest } from 'redux-saga/effects'
import { sagaGet } from '../fetch'
import { API_CUSTOMER_VERTICALS } from '../urls'
import {
  fetchCustomerVerticalsSuccess,
  fetchCustomerVerticalsFail,
  FETCH_CUSTOMERS_VERTICALS,
} from '../stores/customersStore'
import { sagaLogoutUnauthorizedUser } from './logout'
import { UnauthorizedError } from '../helpers'

export function* fetchCustomerVerticalsRequest(action) {
  try {
    const requestURL = `${API_CUSTOMER_VERTICALS}?customer=${action.id}`
    const response = yield call(sagaGet, requestURL)

    if (response.status === 401 || response.status === 403) {
      yield call(sagaLogoutUnauthorizedUser)
      throw new UnauthorizedError()
    }
    const data = yield call([response, response.json])

    yield put(fetchCustomerVerticalsSuccess(data.verticals))
  } catch (error) {
    yield put(fetchCustomerVerticalsFail())
    const mockVerticals = [
      {
        id: 'abc',
        name: 'Finanzen',
        selected: true,
      },
      {
        id: 'def',
        name: 'Netmoms',
        selected: false,
      },
    ]
    yield put(fetchCustomerVerticalsSuccess(mockVerticals))
  }
}

export default function* fetchCustomerVerticalsSaga() {
  yield takeLatest(FETCH_CUSTOMERS_VERTICALS, fetchCustomerVerticalsRequest)
}



// WEBPACK FOOTER //
// ./src/sagas/fetchCustomerVerticals.js